import script from "./SubpageHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./SubpageHeader.vue?vue&type=script&setup=true&lang=js"

import "./SubpageHeader.vue?vue&type=style&index=0&id=6f433c68&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f433c68"]])

export default __exports__